import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { AlertifyService } from '@services/alertify.service';
import { CustomValidators } from '@app/shared/validators/custom.validators';
import { UserService } from '@services/user.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  resetForm: FormGroup;
  email: string;
  token: string;
  showPassword: boolean = false;

  constructor(private fb: FormBuilder, private alertify: AlertifyService, private actRoute: ActivatedRoute,
    private userService: UserService, 
    private router: Router) { }
    

  ngOnInit() {
    this.createResetForm();
    // Try to get from route parameters first (original method)
    this.email = this.actRoute.snapshot.params['email'];
    this.token = this.actRoute.snapshot.params['token'];
    
    // If not found in params, try query parameters (alternative method)
    if (!this.email || !this.token) {
      this.email = this.actRoute.snapshot.queryParams['email'];
      this.token = this.actRoute.snapshot.queryParams['token'];
    }
    
    // No need to decode here - the server will handle the URL decoding
  }

  createResetForm() {
      this.resetForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(6)]]
    }, { validator: CustomValidators.compareTwoPasswords });
  }

  resetPassword() {
    const password: any = this.resetForm.get('password').value;

    this.userService.resetPassword(this.email, password, this.token).subscribe(next => {
      this.alertify.success('Your password had been changed successfully.');
      // tslint:disable-next-line:no-shadowed-variable
    }, error => {
      this.alertify.error(error); //  'Failed to loginsss');
    }, () => {
        this.router.navigate(['/login']);
    }
    );
  }
}
